import { Image, Row, Col, Button } from "react-bootstrap";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { scroller } from 'react-scroll';
import { Link } from 'react-router-dom'


import noMatch from "../../assets/images/404.png"

import styles from "./NoMatchHeaderContent.module.css";

const scrollToSection = () => {
    scroller.scrollTo('homePageVotingSection', { //check Voting.js to find this class
        duration: 300,
        delay: 0,
        smooth: "easeInOutQuart",
    });
}

function NoMatchHeaderContent() {
    const { height, width } = useWindowDimensions();
    return (
        <Row className={styles.ContentContainer}>
            <Col className="d-flex align-items-center">
                <div style={{textAlign: 'center'}}>
                    <div className={styles.headerTitle}>OOPS!</div>
                    <div className={styles.headerSubtext}>We couldn't find your request</div>
                    <Link to="/">
                    <Button className={styles.headerButtons}>
                        <div className={styles.headerButtonText}>Back to Home</div>
                    </Button>
                    </Link>
                    {width < 992 ?
                        <Col>
                            <Link to="/buy-voton">
                                <Button className={styles.headerButtons} onClick={() => scrollToSection()}>
                                    <div className={styles.headerButtonText}>Buy Token</div>
                                </Button>
                            </Link>
                        </Col> : <></>}
                    {width < 992 ?
                        <Col>
                            <Image src={noMatch} className={styles.noMatch}></Image>
                        </Col>
                        : <></>
                    }
                </div>
            </Col>
            {width < 992 ? <></> :
                <Col style={{ textAlign: 'end', position: 'relative' }}>
                    <Image src={noMatch} className={styles.noMatch}></Image>
                </Col>
            }

        </Row>
    );
}

export default NoMatchHeaderContent;
